<template>
  <div :class="$style.page">
    <Loading :loading="loading" text="">
      <!-- back -->
      <Button :class="$style.goBack" type="blue" size="small" @click="goBack">
        <i class="el-icon-arrow-left" /> 返回
      </Button>

      <!-- top -->
      <div :class="$style.top">
        <div :class="$style.top_left">
          <span :class="$style.type">{{ mapTradeStatus[tradeState] }}</span>

          <span :class="$style.money">
            实付金额：
            <span class="theme-color">{{ amount }}元</span>
          </span>
        </div>

        <div v-if="tradeState === 0" :class="$style.top_right">
          <Button type="primary" @click="toPay">付款</Button>
          <Button type="primary2" @click="toCancel">取消</Button>
        </div>
      </div>

      <Divider />

      <!-- 订单简况 -->
      <Item title="订单号" :class="$style.item">{{ orderNo }}</Item>
      <Item title="创建时间" :class="$style.item">{{ createdTime }}</Item>
      <Item v-if="tradeState === 1" title="付款时间" :class="$style.item">{{
        payTime || "-"
      }}</Item>

      <!-- 订单列表 -->
      <Title title="产品信息" :count="totalCount" />

      <el-table
        :data="showList"
        :fit="true"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="name" label="序号" width="30" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>

        <el-table-column
          prop="goodsName"
          label="产品名称"
          width="120"
          align="center"
        />

        <el-table-column label="类型" width="50" align="center">
          <template slot-scope="scope">
            <span class="theme-color">{{ mapType[scope.row.type] }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="id" label="单价" width="80" align="center">
          <template slot-scope="scope">{{ scope.row.price }}元/年</template>
        </el-table-column>

        <el-table-column label="数量" width="80" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.counts }}</span>
          </template>
        </el-table-column>

        <el-table-column label="小计" width="80" align="center">
          <template slot-scope="scope">
            <span class="theme-color">
              {{ scope.row.price * scope.row.counts }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="expireTime"
          label="状态"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <span class="theme-color">
              {{ mapStatus[scope.row.status] }}
            </span>
          </template>
        </el-table-column>
      </el-table>

      <div :class="$style.total">
        合计：
        <span :class="$style.total_number"> {{ total }} 元 </span>
      </div>
    </Loading>
  </div>
</template>

<script>
import { deleteOrder, getOrderDetail } from "@server";

export default {
  name: "OrderDetail",
  data() {
    return {
      orderNo: "",

      mapTradeStatus: ["待支付", "已支付", "已取消", "已过期"],
      tradeState: "",
      createdTime: "",
      payTime: "",
      amount: 0, // 实际支付
      total: 0, // 合计金额

      loading: false,
      showList: [],
      totalCount: 0,
      mapType: ["注册", "续费", "转入"],
      mapStatus: ["未处理", "处理中", "成功", "失败", "取消"],
    };
  },
  methods: {
    async getDetail() {
      if (!this.orderNo) return;

      this.loading = true;
      const res = await getOrderDetail({ orderNo: this.orderNo });
      const { code, data } = res;

      if (code === 200) {
        this.tradeState = data.state;
        this.createdTime = data.createdTime;
        this.payTime = data.payTime;
        this.amount = data.amount;
        this.total = data.total;

        this.showList = data.orderDetailList;
        this.totalCount = data.orderDetailList.length;
      }
      this.loading = false;
    },

    goBack() {
      this.$router.push("/user/domain-order");
    },

    toPay() {
      this.orderNo && this.$router.push(`/cart?orderNo=${this.orderNo}`);
    },

    async toCancel() {
      if (!this.orderNo) return;

      const res = await deleteOrder({ orderNo: this.orderNo });

      if (res.code === 200) {
        this.$message({ message: "订单取消成功", type: "success" });
        this.$router.push(`/user/domain-order`);
      } else {
        this.$message({ message: "订单取消失败", type: "error" });
      }
    },
  },
  created() {
    const { query } = this.$route;
    this.orderNo = query.orderNo;
    this.getDetail();
  },
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: 300px;
  padding: rem(50);
  background: $white;
  box-shadow: $box-shadow;

  font-size: rem(14);
  color: #333;

  :global {
    .gl-divider {
      margin: rem(40) 0;
    }

    .gl-item {
      margin-bottom: rem(30);
      padding-left: 20px;
    }
  }

  .goBack {
    border-radius: 0 rem(25) rem(25) 0;

    :global {
      .el-icon-arrow-left {
        margin-left: -5px;
        padding-right: 5px;
      }
    }
  }

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    margin-top: rem(50);

    .top_left {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      .type {
        margin-right: 20px;
        font-size: max(rem(18), 15px);
        font-weight: bold;
      }

      .money {
        font-size: 14px;
      }
    }
  }

  .total {
    margin: 30px 0;
    font-size: 14px;
    color: #333;
    text-align: right;

    .total_number {
      font-weight: bold;
      color: $theme-color;
      padding-right: 20px;
    }
  }
}
</style>
